import {makeAutoObservable} from "mobx";
import {api} from "../../api";
import {provider} from "../../Router";
import {growlStore} from "../GrowlStore";

const vrsPrefix = 'vrs:'

class VhsBarcodeScanStore {
    constructor() {
        makeAutoObservable(this)
    }

    async notify(val: string) {
        if (val.startsWith(vrsPrefix)) {
            const documentIdCandidate = val.substring(vrsPrefix.length)
            try {
                const response = await api.vhs.api.findVehiclesByDocumentId({documentId: documentIdCandidate})
                const items = response.data || []
                if (items.length === 1) {
                    const {
                        customerId,
                        vin
                    } = items[0]
                    provider.router.navigate(`/vhs/${customerId}/${vin}`)
                } else {
                    growlStore.add({
                        closable: true,
                        message: `Dokumenten-Id "${documentIdCandidate}" nicht gefunden oder eindeutig`,
                        autoclose: 5000,
                        cls: 'is-warning'
                    })
                }
            } catch (e) {}
        }
    }
}

const vhsBarcodeScanStore = new VhsBarcodeScanStore()

export { vhsBarcodeScanStore }
